import React from 'react';
import PropTypes from 'prop-types';
import { BreakpointsProvider, defaultBreakpoints } from './BreakpointsProvider';
import {
  processPropertiesForState,
  handleDimensionEvent
} from './helpers/breakpointsSize';
import merge from 'lodash.merge';

/** `Breakpoints` component is used for setting s, m, & l widths for responsive layouts. Uses _context_ to provide components nested within (like `Col` & `On`) with breakpoint sizes */
export default class Breakpoints extends React.Component {
  static propTypes = {
    /** defines small breakpoint, default is 300(pixels)*/
    s: PropTypes.number,
    /** defines medium breakpoint, default is 750(pixels) */
    m: PropTypes.number,
    /** defines large breakpoint, default is 1100(pixels) */
    l: PropTypes.number,
    /** defines preference for size to server-side-render. If Breakpoints determines that it is being server-side-rendered, the size specified in this prop will be given the value of 'true' in the breakpoints context object.
     */
    ssrSize: PropTypes.oneOf(['defaultSize', 's', 'm', 'l']),
    /** elements to be rendered, including BreakpointsConsumers to receive breakpoints value */
    children: PropTypes.any
  };

  // entire state object is passed to provider
  state = defaultBreakpoints;

  static getDerivedStateFromProps(props, state) {
    const { s, m, l, ssrSize } = props;
    const breakpoints = merge(defaultBreakpoints, { s, m, l, ssrSize });

    return {
      ...state,
      ...breakpoints,
      ...processPropertiesForState(breakpoints)
    };
  }

  handleDimensionEvent = handleDimensionEvent.bind(this)();

  componentDidMount() {
    if (this.handleDimensionEvent.eventAvailable) {
      this.handleDimensionEvent.addDimensionEventListener();
    }
    // fire resize event for SSR sync
    if (
      typeof document !== 'undefined' &&
      document.createEvent &&
      document.dispatchEvent
    ) {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, false);
      document.dispatchEvent(event);
    }
  }

  componentWillUnmount() {
    if (this.handleDimensionEvent.eventAvailable) {
      this.handleDimensionEvent.removeDimensionEventListener();
    }
  }

  getCurrentBreakpoints = () => {
    const { s, m, l } = this.state;
    return { s, m, l };
  };

  render() {
    return (
      <BreakpointsProvider value={this.state}>
        {this.props.children}
      </BreakpointsProvider>
    );
  }
}
